/**
 * Renders an HTML string the same way the frontend project's TextContainer does:
 * dangerouslySetInnerHTML + typographic styles for p, ul, ol, table, a, img.
 */
function HtmlContent({
  html,
  className,
}: {
  html: string;
  className?: string;
}) {
  // Open external links in a new tab (mirrors TextContainer behaviour).
  const sanitized = html.replaceAll(
    '<a href="http',
    '<a target="_blank" rel="nofollow noreferrer" href="http',
  );

  return (
    <div
      className={[
        // paragraphs / block elements
        "[&_p]:mb-4 [&_pre]:mb-4 [&_ul]:mb-4 [&_ol]:mb-4 [&_table]:mb-4",
        // lists
        "[&_ul]:list-disc [&_ol]:list-decimal [&_ul]:pl-5 [&_ol]:pl-5",
        "[&_li]:mb-1",
        // links
        "[&_a]:underline [&_a:hover]:text-iq-orange",
        // images
        "[&_img]:block [&_img]:max-w-full [&_img]:max-h-[400px] [&_img]:object-contain [&_img]:mx-auto",
        // tables
        "[&_th]:px-1.5 [&_th]:py-0.5 [&_th]:border [&_th]:border-iq-grey-medium [&_th]:font-semibold [&_th]:bg-iq-grey-light",
        "[&_td]:px-1.5 [&_td]:py-0.5 [&_td]:border [&_td]:border-iq-grey-medium",
        // last child no bottom margin
        "[&>*:last-child]:mb-0",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
}

export { HtmlContent };
